module.exports = __webpack_public_path__ + "static/media/dragIcon.9ad95d9c.svg";